import { put, takeEvery, call } from "redux-saga/effects"
import { authRequest } from "engine/modules/authRequest"
import env from "src/env"
import { MARK_READ_ONE } from "../actions/types"
import { markOneReadSuccess, markOneReadError } from "../actions/creators"

const { REACT_APP_NOTIFICATION_API_URL } = env

// marl current notification read
function* requestMarkOne(action) {
  const { notificationUuid } = action.config

  try {
    yield call(authRequest, {
      url: `${REACT_APP_NOTIFICATION_API_URL}/notification/mark-read`,
      method: `post`,
      data: {
        uuids: [notificationUuid],
      },
    })

    yield put(markOneReadSuccess(action, notificationUuid))
  } catch (error) {
    yield put(markOneReadError(action, error))
  }
}

export default function* markOneSaga() {
  yield takeEvery(MARK_READ_ONE, requestMarkOne)
}
